export default __webpack_public_path__ + "static/media/2.4ee653e3.jpg";